import React from "react";
import { Link } from "react-router-dom";
export default function CsrPolicy() {
  return (
    <>
      <p>
        At Dox and Box, we believe that business growth and social responsibility go hand in hand. Our CSR approach reflects our commitment to creating a positive impact on society, the environment, the communities we serve—while operating with integrity, transparency, accountability.
      </p>

      <h3 className="heading">CSR Vision</h3>
      <p>To contribute meaningfully towards sustainable development by supporting initiatives that promote environmental responsibility, digital empowerment, community well-being.
      </p>

      <h3 className="heading">CSR Focus Areas</h3>
      <p>Our CSR initiatives are aligned with the evolving needs of society and our core business values.
      </p>

      <h3 className="heading">Environmental Sustainability</h3>
      <p>We are committed to reducing our environmental footprint by promoting paperless operations, responsible resource usage, eco-friendly practices. Through document digitization and secure destruction services, we help organizations move towards greener, more sustainable business processes.

      </p>

      <h3 className="heading">Digital Transformation & Education</h3>
      <p>We support initiatives that enhance digital literacy and access to technology. By encouraging the adoption of digital tools and knowledge-sharing, we aim to empower individuals and organizations to thrive in a digital-first world.
      </p>

      <h3 className="heading">Community Development</h3>
      <p>We actively contribute to community welfare through initiatives focused on education, skill development, social upliftment. Our goal is to create long-term value and support inclusive growth across communities.
      </p>

      <h3 className="heading">Data Responsibility & Ethical Practices</h3>
      <p>As a document management solutions provider, we prioritize responsible data handling, confidentiality, ethical business practices. We are committed to maintaining trust and protecting sensitive information across all operations.
      </p>

      <h3 className="heading">Governance & Implementation</h3>
      <p>Our CSR activities are guided by a structured approach that ensures transparency, accountability, measurable impact. We evaluate and support initiatives that align with our values and comply with applicable regulations, including provisions under the Companies Act, 2013 (India), wherever applicable.
      </p>

      <h3 className="heading">Employee Participation</h3>
      <p>We encourage our employees to actively participate in CSR initiatives through volunteering, awareness programs, community engagement activities. By fostering a culture of responsibility, we aim to create a collective impact beyond business operations.
      </p>

      <h3 className="heading">Partnerships & Collaboration</h3>
      <p>
        We collaborate with credible organizations, NGOs, institutions to implement CSR initiatives effectively. These partnerships help us extend our reach and deliver meaningful, sustainable outcomes.
      </p>

      <h3 className="heading">Monitoring & Reporting</h3>
      <p>We regularly monitor the progress and impact of our CSR initiatives to ensure effectiveness and alignment with our goals. Where applicable, CSR activities and outcomes are documented and reported in accordance with regulatory requirements.
      </p>

      <h3 className="heading">Continuous Improvement</h3>
      <p>
        Dox and Box is committed to continuously enhancing its CSR efforts by identifying new opportunities, adopting sustainable practices, responding to emerging social and environmental challenges.
      </p>

      <h3 className="heading">Contact Us</h3>
      <p>For more information about our CSR initiatives or to explore collaboration opportunities, please contact:
      </p>
      <p>Email: <Link to={"mailto:info@doxandbox.com"}>info@doxandbox.com</Link>
        <br />
        Phone: <Link to={"tel:+91-9580374374"}>+91-9580374374</Link></p>
    </>
  );
}
